import React, { ReactNode } from "react";
import { Button, SxProps, Theme } from "@mui/material";

type CustomButtonProps = {
  children: ReactNode;
  bg?: string;
  rounded?: string;
  color?: string;
  width?: string;
  height?: string;
  variant?: any;
  icon?: ReactNode;
  onClick?: () => void;
  className?: string;
  sx?: SxProps<Theme>; // Accept sx prop for MUI styling
  type?: "submit" | "button" | "reset";
  disabled?: boolean;
};

const CustomButton: React.FC<CustomButtonProps> = ({
  children,
  bg = "primary",
  rounded = "8px",
  color = "white",
  width = "auto",
  height = "auto",
  variant = "contained",
  icon,
  onClick,
  className = "",
  sx = {},
  type = "button",
  disabled = false,
}) => {
  return (
    <Button
      variant={variant}
      sx={{
        textTransform: "capitalize",
        fontWeight: "500",
        borderRadius: rounded,
        backgroundColor: bg,
        color,
        height,
        width,
        padding: "8px 20px",
        "&:hover": { backgroundColor: bg, opacity: 0.85 },
        ...sx,
      }}
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`flex items-center whitespace-nowrap gap-2 justify-center transition-all duration-300 ${className}`}
    >
      <span>{children}</span>
      {icon && <span>{icon}</span>}
    </Button>
  );
};

export default CustomButton;
